<template>
  <header class="w3-container w3-top w3-hide-large w3-pink w3-xlarge w3-padding">
    <button class="w3-button w3-pink w3-margin-right" @click="showNavbar">☰</button>
    <div class="locale-container">
      <img src="~@/assets/flag_hu.png" alt="flag hu" @click="$store.commit('setLocale', 'hu')">
      <img src="~@/assets/flag_en.png" alt="flag en" @click="$store.commit('setLocale', 'en')">
      <img src="~@/assets/flag_de.png" alt="flag de" @click="$store.commit('setLocale', 'de')">
    </div>
  </header>
</template>

<script>
  export default {
    name: 'page-header',
    methods: {
      showNavbar() {
        this.$store.commit('setNavbarVisibility', true);
      },
    },
  };

</script>

<style scoped>
  header {
    background-color: #eb2e4a !important;
  }

  button {
    background-color: #eb2e4a !important;
  }

  .locale-container {
    float: right;
  }

  .locale-container img {
    cursor: pointer;
    user-select: none;
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// PageHeader.vue?4255dbe1